import React from 'react'
import { Helmet } from 'react-helmet'

function Services() {
  return (
    <>
      <Helmet>
        <title>Services - Oxford College</title>
        <meta name="description" content="Learn more about the educational and support services offered by Oxford College." />
        <meta name="keywords" content="Services, Education, Support, Oxford College" />
        <meta name="author" content="Oxford College - Gampaha" />
        <meta property="og:title" content="Services - Oxford College - Gampaha" />
        <meta property="og:description" content="Discover the variety of services we offer to enhance your learning experience." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://oxfordcollege.lk/services" />
        <meta property="og:image" content="https://www.facebook.com/photo/?fbid=127196623392555&set=a.127196626725888" />
      </Helmet>
      <div>Services</div>
    </>
  )
}

export default Services